import request from '@/utils/request'

// 表格檢測
export function detectTable(file) {
  const formData = new FormData()
  formData.append('file', file)
  
  return request({
    url: '/infer/detect',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 圖片裁剪
export function cropImage(data) {
  return request({
    url: '/infer/crop',
    method: 'post',
    data: {
      base64Img: data.base64Img,
      cropData: data.cropData
    }
  })
}

// 表格識別
export function recognizeTable(file) {
  const formData = new FormData()
  formData.append('file', file)
  
  return request({
    url: '/infer/recognize',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}